import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import _ from 'lodash';

const EditableTextWrapper = styled.input`
  background: transparent;
  border: none;
`;

const EditableText = ({ value, onEdit }) => {
  const [inputValue, setInputValue] = useState(value);

  const resetValue = () => setInputValue(value);
  const onKeyDown = e => {
    if (e.keyCode === 13) {
      // pressed Enter
      e.preventDefault();
      e.target.blur();
      onEdit(inputValue);
    }
  };

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <EditableTextWrapper
      type='text'
      value={inputValue}
      onChange={e => setInputValue(e.target.value)}
      onBlur={resetValue}
      onKeyDown={onKeyDown}
      size={_.size(inputValue)}
    />
  );
};

export default EditableText;
